<template>
    <div class="page">

        <Top></Top>

        <div class="hidden-xl hidden-lg navbar navbar-style-1">
            <div class="navbar-inner">
                <a v-on:click="$root.back();" class="link back">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z" fill="black"></path>
                    </svg>
                </a>
                <div class="title" v-if="!form.cod">Adicionar usuário</div>
                <div class="title" v-if="form.cod">Editar usuário</div>
                <div class="right">
                    <a style="opacity: 0" class="link panel-open" data-panel="left">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 12C14 10.8955 13.1046 10 12 10C10.8954 10 10 10.8955 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12Z" fill="black"></path>
                            <path d="M14 20C14 18.8954 13.1046 18 12 18C10.8954 18 10 18.8954 10 20C10 21.1045 10.8954 22 12 22C13.1046 22 14 21.1045 14 20Z" fill="black"></path>
                            <path d="M14 4C14 2.89544 13.1046 2.00001 12 2.00001C10.8954 2.00001 10 2.89544 10 4C10 5.10457 10.8954 6 12 6C13.1046 6 14 5.10457 14 4Z" fill="black"></path>
                        </svg>
                    </a>
                </div>
            </div>
        </div>        
        <div class="page-content">

            <div class="container hidden-xs hidden-md">
                <h2>{{form.cod ? 'Editar' : 'Cadastrar'}} usuário</h2>
            </div>

            <div class="">
                <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">
                
                    <div class="list" style="margin-top: 16px">
                        <ul class="row">
                            <li class="item-content col-100" v-if="form.tipo == 'admin' && !form.cod">
                                <div class="item-inner">                            
                                    <div class="item-title item-label">Tipo do usuário:</div>
                                </div>     
                            </li>     
                            <li class="col-100" v-if="form.tipo == 'admin' && !form.cod">
                                <label class="item-radio item-radio-icon-start item-content">
                                    <input  v-model="form.tipo" type="radio" name="usuario-tipo" value="admin">
                                    <i class="icon icon-radio"></i>
                                    <div class="item-inner">
                                        <div class="item-title">Administrador</div>
                                    </div>
                                </label>
                            </li>
                            <li class="item-content item-input col-100" v-if="form.tipo == 'prestador'">
                                <div class="item-inner">
                                    <div class="item-title item-label">Qual a profissão? <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <select id="categoriaCod" class="form-control" name="categoriaCod" required="" v-model="form.categoriaCod">
                                            <option value="" disabled selected hidden>Selecione..</option>
                                            <option v-for="(item, index) in profissoes.itens" v-if="item.tipo == 'profissao'" :key="item.cod + '-slide'" :value="item.cod" >{{item.nome}}</option>
                                           
                                        </select>                                                  
                                    </div>
                                </div>
                            </li>        
                            <li class="item-content item-input col-100" v-if="form.tipo == 'prestador'">
                                <div class="item-inner">
                                    <div class="item-title item-label">Especialidade(s) <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap" v-on:click="autocompleteEspecialidades()">
                                        <input type="text" placeholder="" readonly="" value="" class="form-control" v-model="especialidades.nomes"/>
                                    </div>
                                </div>
                            </li>                                                                                       
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label" v-if="form.tipo == 'contratante' || form.tipo == 'admin'">Nome <small>(obrigatório)</small></div>
                                    <div class="item-title item-label" v-if="form.tipo == 'prestador'">Nome do responsável <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <input type="text" v-model="form.nome" placeholder="Esreva o nome" value="" class="form-control"/>
                                    </div>
                                </div>
                            </li>
                            <li class="item-content item-input col-100" v-if="form.tipo == 'prestador'">
                                <div class="item-inner">
                                    <div class="item-title item-label">Registro de classe <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <input type="text" v-model="form.registroClasse" placeholder="Escreva aqui.." value="" class="form-control"/>
                                    </div>
                                </div>
                            </li>                                    
<!--                                     <li class="item-content item-input col-100" v-if="form.tipo == 'prestador'">
                                <div class="item-inner">
                                    <div class="item-title item-label">Nome da empresa <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <input type="text" v-model="form.empresa" placeholder="Nome fantasia da empresa" value="" class="form-control"/>
                                    </div>
                                </div>
                            </li>
                            <li class="item-content item-input col-100" v-if="form.tipo == 'prestador'">
                                <div class="item-inner">
                                    <div class="item-title item-label">Razão social <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <input type="text" v-model="form.razaoSocial" placeholder="Razão social da empresa" value="" class="form-control"/>
                                    </div>
                                </div>
                            </li>  -->                                   
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">E-mail <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <input type="email" v-model="form.email" placeholder="Esreva o e-mail" value="" class="form-control"/>
                                    </div>
                                </div>
                            </li>
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Celular <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="form-control" placeholder="Escreva o celular" autocomplete="new-password" v-model="form.telefone" />
                                    </div>
                                </div>
                            </li>                                    
                            <li class="item-content item-input col-100" v-if="form.tipo != 'admin'">
                                <div class="item-inner">
                                    <div class="item-title item-label" v-if="form.tipo == 'contratante' || form.tipo == 'admin'">CPF <small>(obrigatório)</small></div>
                                    <div class="item-title item-label" v-if="form.tipo == 'prestador'">CPF do profissional <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <the-mask :mask="['###.###.###-##']" type="tel" class="form-control" autocomplete="new-password" v-model="form.doc" placeholder="Informe o CPF" required />
                                    </div>
                                </div>
                            </li>             
<!--                                     <li class="item-content item-input col-100" v-if="form.tipo == 'prestador'">
                                <div class="item-inner">
                                    <div class="item-title item-label">CNPJ <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <the-mask type="tel" :mask="['##.###.###/####-##']" class="form-control" v-model="form.cnpj" :placeholder="'Informe o CNPJ da empresa'"/>
                                    </div>
                                </div>
                            </li>                                 -->                      
                            <li class="item-content item-input col-100" v-if="form.tipo == 'contratante'">
                                <div class="item-inner">
                                    <div class="item-title item-label" v-if="form.tipo == 'contratante'">Data de nascimento <small>(obrigatório)</small></div>
                                    <!-- <div class="item-title item-label" v-if="form.tipo == 'prestador'">Data de nascimento do profissional <small>(obrigatório)</small></div> -->
                                    <div class="item-input-wrap">
                                        <the-mask :mask="['##/##/####']" :masked="true" type="tel" placeholder="Sua data de nascimento" value="" class="form-control" autocomplete="new-password" v-model="form.dataNascimento"  required />
                                    </div>
                                </div>
                            </li>    
                            <li class="item-content item-input col-100" v-if="form.tipo == 'prestador'">
                                <div class="item-inner">
                                    <div class="item-title item-label">Currículo <small>(opcional)</small></div>
                                    <div class="item-input-wrap">
                                        <textarea v-model="form.descricao" style="min-height: 250px; background: #f7f7f7; padding: 5px" placeholder="Escreva o currículo aqui.." class="form-control"></textarea>
                                    </div>
                                </div>
                            </li>                                                                                                                   
                        </ul>

                        <p style="padding-left: 12px" v-if="form.tipo == 'prestador'">
                            <i class="las la-map-marker"></i> 
                            Endereço
                        </p>

                        <ul class="row" v-if="form.tipo == 'prestador'">
                            <li class="item-content item-input col-60" v-if="form.tipo == 'prestador'">
                                <div class="item-inner">
                                    <div class="item-title item-label">CEP <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <the-mask :mask="['#####-###']" :masked="true" type="tel" class="form-control" v-model="form.cep" placeholder="_____-___" />
                                    </div>
                                </div>
                            </li>
                            <li class="item-content item-input col-100" v-if="form.tipo == 'prestador'">
                                <div class="item-inner">
                                    <div class="item-title item-label">Rua <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <input type="text" v-model="form.endereco" placeholder="Escreva o endereço.." value="" class="form-control" />
                                    </div>
                                </div>
                            </li>
                            <li class="item-content item-input col-100" v-if="form.tipo == 'prestador'">
                                <div class="item-inner">
                                    <div class="item-title item-label">Número (opcional)</div>
                                    <div class="item-input-wrap">
                                        <input type="tel" v-model="form.numero" placeholder="__" value="" class="form-control" />
                                    </div>
                                </div>
                            </li>
                            <li class="item-content item-input col-100" v-if="form.tipo == 'prestador'">
                                <div class="item-inner">
                                    <div class="item-title item-label">Complemento <small>(opcional)</small></div>
                                    <div class="item-input-wrap">
                                        <input type="text" v-model="form.complemento" placeholder="" value="" class="form-control"/>
                                    </div>
                                </div>
                            </li>     
                            <li class="item-content item-input col-100" v-if="form.tipo == 'prestador'">
                                <div class="item-inner">
                                    <div class="item-title item-label">Bairro <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <input type="text" v-model="form.bairro" placeholder="Escreva o bairro.." value="" class="form-control" />
                                    </div>
                                </div>
                            </li>            
                            <li class="item-content item-input col-100" v-if="form.tipo == 'prestador'" >
                                <div class="item-inner">
                                    <div class="item-title item-label">Cidade <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <input type="text" v-model="form.cidade" placeholder="Escreva a cidade.." value="" class="form-control" />
                                    </div>
                                </div>
                            </li>     
                            <li class="item-content item-input col-100" v-if="form.tipo == 'prestador'">
                                <div class="item-inner">
                                    <div class="item-title item-label">Estado <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <select id="estado" class="form-control" readonly="" name="estado" required="" v-model="form.estado" >
                                            <option value="" disabled selected hidden>Estado</option>
                                            <option value="AC">Acre</option>
                                            <option value="AL">Alagoas</option>
                                            <option value="AP">Amapá</option>
                                            <option value="AM">Amazonas</option>
                                            <option value="BA">Bahia</option>
                                            <option value="CE">Ceará</option>
                                            <option value="DF">Distrito Federal</option>
                                            <option value="ES">Espírito Santo</option>
                                            <option value="GO">Goiás</option>
                                            <option value="MA">Maranhão</option>
                                            <option value="MT">Mato Grosso</option>
                                            <option value="MS">Mato Grosso do Sul</option>
                                            <option value="MG">Minas Gerais</option>
                                            <option value="PA">Pará</option>
                                            <option value="PB">Paraíba</option>
                                            <option value="PR">Paraná</option>
                                            <option value="PE">Pernambuco</option>
                                            <option value="PI">Piauí</option>
                                            <option value="RJ">Rio de Janeiro</option>
                                            <option value="RN">Rio Grande do Norte</option>
                                            <option value="RS">Rio Grande do Sul</option>
                                            <option value="RO">Rondônia</option>
                                            <option value="RR">Roraima</option>
                                            <option value="SC">Santa Catarina</option>
                                            <option value="SP">São Paulo</option>
                                            <option value="SE">Sergipe</option>
                                            <option value="TO">Tocantins</option>
                                        </select>                                                  
                                    </div>
                                </div>
                            </li>  
                        </ul>                                  
                    </div>                                                                                                                   
                        
                    <div class="block" style="">
                        <small v-if="!form.cod">Após salvar, o usuário receberá um e-mail com a senha de acesso gerada aleatóriamente pelo sistema.</small>

                        <button type="submit" class=" button-large button button-fill mt-10">
                            <i class="las la-save"></i>
                            Salvar
                        </button>
                    </div>
                </form>

            </div>
        </div>
        
    </div>     
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'
export default {
    name: 'GerenciarUsuarios',
    components: {
        'Toolbar': Toolbar,
        'Top': Top
    },          
    data () {
        var self                    = this;
        return {
            "loading": {
                "submit":           false
            },
            "categorias": {
                "itens":            []
            },         
            "especialidades": {
                "nomes":            "",
                "valor":            [
                ],
                "itens":            [                 
                ]
            },
            "profissoes": {
                "itens":            []
            },                             
            "form": {
                "_cod":             "",
                "_token":           "",
                "nome":             "",
                "tipo":             "admin",
                "email":            "",
                "telefone":         "",
                "estado":           "",
                "empresaCod":       "",
                "dataNascimento":   "",
                "doc":              ""
            }            
        }
    },
    watch: {
        "form.cep": function(val) {
            var self = this;
            self.atualizarCEP(val);
        },
    },    
    methods: {
        atualizarCEP: function(val) {
            var self    = this;
            if (val) {
                if (val.length == 9) {
                    axios.get("https://viacep.com.br/ws/" + val.replace("-", "") + "/json/", {})
                    .then(response => {
                        if (response.data) {
                            if (response.data.logradouro) {
                                self.form.endereco  = response.data.logradouro;
                                self.form.bairro    = response.data.bairro;
                                self.form.cidade    = response.data.localidade;
                                self.form.estado    = response.data.uf;
                                self.$forceUpdate();
                            }
                        }
                    })
                    .catch(error => {
                    });
                }
            }
        },  
        autocompleteEspecialidades: function() {
            var self = this;
            console.log("autocompleteEspecialidades()");

            self.autocomplete = window.___app.autocomplete.create({
                // inputEl: '.autocomplete-dropdown-especialidades',
                openIn: 'popup',
                // preloader: true, 
                multiple: true,
                requestSourceOnOpen: true,
                // updateInputValueOnSelect: true,
                closeOnSelect: false,
                valueProperty: 'cod',
                textProperty: 'nome',
                popupCloseLinkText: "Fechar",
                notFoundText: "Nenhum resultado encontrado.",
                searchbarDisableText: "Cancelar",
                searchbarPlaceholder: "Pesquise..",
                value: self.especialidades.valor,
                // limit: 20,
                // typeahead: true,
                // dropdownPlaceholderText: 'Selecione as especialidades..',
                source: function (query, render) {
                    var autocomplete = this;
                    var results = [];
                    autocomplete.preloaderShow();

                    var clean = function(val) {
                        return (val ? val : "").toLowerCase().replace(/[^a-zA-Z0-9]/g, "").trim();
                    }

                    var itens = [];                        
                    var search= clean(query);

                    if (!self.form.categoriaCod) {
                        console.log("Erro autocomplete", self.autocomplete);
                        setTimeout(function() {
                            self.autocomplete.close();
                        }, 1000);
                        alert("Selecione a sua profissão.");
                        return false;
                    }

                    self.especialidades.itens.forEach(function(item) {
                        console.log("VALIDA >>> ", item, "categoriaCod:", self.form.categoriaCod, "==", item.categoriaCod);
                        if ((clean(item.nome).indexOf(search) != -1) && item.categoriaCod == self.form.categoriaCod) {
                            itens.push(item);
                        }
                    });

                    autocomplete.preloaderHide();
                    render(itens);

                },
                on: {
                    change: function (value) {
                        console.log("change", value);

                        self.especialidades.valor = value;

                        var nomes   = "";

                        value.forEach(function(item) {
                            nomes += item.nome + ", ";
                        });

                        nomes       = nomes.substr(0, nomes.length - 2);

                        self.especialidades.nomes = nomes;
                   
                        self.$forceUpdate();
                    },
                }                
            });

            console.log("autocomplete:", self.autocomplete)

            self.autocomplete.open();

        },        
        submit: function(e) {
            var self            = this;
            // if (self.form.tipo != "admin" && self.form.tipo != "prestador") return false;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;

            var self            = this;
            if (self.form.tipo == "prestador") {
                self.form.categoriasNomes       = self.especialidades.nomes;
                self.form.categorias            = [];
                self.especialidades.valor.forEach(function(item) {
                    self.form.categorias.push(item.cod);
                });
                self.form.categorias            = self.form.categorias.join(",");
            }             

            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            loading.show();

            var request = function() {
                
                var a = "post";
                if (self.form.cod) {
                    a = "put";
                }

                axios[a]("api/usuarios.php", self.form)
                .then(response => {
                    console.log("ok", response.data.result)

                    $(".page-content")[0].scrollTo({
                        top: 5
                    });                                             
                    loading.hide();
                    self.$root.getUser();
                    alert(response.data.message);
                    // self.$root.setUser(response.data.result);

                })
                .catch(error => {
                    loading.hide(); 
                    alert(error.response.data.message || "Erro! Por favor, tente novamente.");
                });
            }

            if (self.form.tipo == "prestador") {
                var geocoder                = new google.maps.Geocoder();
                var endereco                = self.form.endereco + ", " + self.form.numero + " - " + self.form.bairro + ", " + self.form.cidade + " - " + self.form.estado + ", " + self.form.cep;
                geocoder.geocode({ 'address': endereco}, function (results, status) {

                    console.log("Localizacao resultado >>", results)

                    if (results[0]) {

                        var latitude        = results[0].geometry.location.lat();
                        var longitude       = results[0].geometry.location.lng();
                        self.form.latitude  = latitude;
                        self.form.longitude = longitude;
                        console.log("Setou localizacao", self.form);
                        self.$forceUpdate();
                        request();
                    } else {
                        loading.hide();
                        alert("Erro! Informe um endereço válido e tente novamente por favor.")
                    }

                });                  
            } else {
                request();
            }

        },
        // getCategorias: function() {
        //     var self        = this;
        //     console.log("getCategorias()");
        //     // loading.show();
        //     return new Promise(function(resolve, reject) {

        //         var form = {
        //             "params": {
        //                 "_cod":         self.$root.user.cod, 
        //                 "_token":       self.$root.user.token,
        //                 "all":          true
        //             }
        //         };

        //         axios.get("api/categorias.php", form)
        //         .then(response => {
                    
        //             console.log("getCategorias() response", response);
        //             self.categorias                     = response.data.result;
        //             // loading.hide();
        //             resolve(response.data.result);
  
        //         })
        //         .catch(error => {
        //             console.log("getCategorias() error", error);                    
        //             // loading.hide();
        //             reject(error);
        //             alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                           
        //         });   

        //     });   
        // }, 
        getCategorias: function() {
            var self        = this;
            console.log("getCategorias()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "all":          true
                    }
                };

                axios.get("api/categorias.php", form)
                .then(response => {
                    
                    console.log("getCategorias() response", response);
                    self.categorias                     = response.data.result;

                    console.log("Buscou categorias", self.categorias);

                    var profissoes      = [];
                    var especialidades  = [];
                    var especialidadesCods = self.form.categorias.split(",");
                    self.especialidades.valor = [];

                    self.categorias.itens.forEach(function(item) {
                        if (item.tipo == "profissao") {
                            profissoes.push(item);
                        }
                        if (item.tipo == "especialidade") {

                            if (especialidadesCods.indexOf(item.cod) != -1) {
                                console.log("Possui cod", item);
                                self.especialidades.valor.push(item);
                            }

                            especialidades.push(item);
                        }                        
                    });

                    self.especialidades.nomes   = self.form.categoriasNomes;
                    self.especialidades.itens   = especialidades;
                    self.profissoes.itens       = profissoes;


                    console.log("Especialidades:", especialidadesCods);

                    console.log("Setou especialidades e profissoes", self.especialidades, self.profissoes)

                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getCategorias() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                           
                });   

            });   
        },          
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/usuarios.php", form)
                .then(response => {
                    
                    console.log("get() response", response);

                    var d               = response.data.result.dataNascimento.split("-");
                    response.data.result.dataNascimento = d[2] + "/" + d[1] + "/" + d[0];
                    self.form           = response.data.result;
                    self.loaded         = true;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        }        
    },    
    created: function() {
        var self = this;
        console.log("created", self);

        if (self.$route.query.tipo) {
            self.form.tipo = self.$route.query.tipo;
            self.$forceUpdate();
        }

        if (self.$route.name == "EditarUsuariosGeral") {
            if (!self.$route.query.c) {
                self.$root.back();
                return false;
            }
            self.form.cod = self.$route.query.c;
            self.get().finally(function() {
                self.getCategorias();
            });
        } else {
            loading.hide();
        }
    },
    mounted: function() {
    }      
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
   
</style>



// WEBPACK FOOTER //
// src/components/GerenciarUsuarios.vue